// Appels aux routes /auth/* et /admin/* de l'API (api/auth_routes.py). Chaque fonction
// renvoie le JSON de la réponse, ou lève une Error dont le message est affichable tel quel.

const API_URL = process.env.REACT_APP_API_URL;
const ME_TIMEOUT_MS = 6000;

async function request(method, path, body, { signal } = {}) {
    let response;
    try {
        response = await fetch(`${API_URL}${path}`, {
            method,
            headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
            body: body !== undefined ? JSON.stringify(body) : undefined,
            signal,
        });
    } catch (error) {
        throw new Error('Serveur injoignable : vérifiez la connexion.');
    }
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(data.error || `Erreur ${response.status}`);
        error.status = response.status;
        throw error;
    }
    return data;
}

// Délai court : sur un wifi sans accès internet, l'app doit pouvoir démarrer sur le
// dernier état connu au lieu d'attendre indéfiniment.
export async function apiMe() {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), ME_TIMEOUT_MS);
    try {
        return await request('GET', '/auth/me', undefined, { signal: controller.signal });
    } finally {
        clearTimeout(timeoutId);
    }
}

export const apiLogin = (email, password) => request('POST', '/auth/login', { email, password });
export const apiLogout = () => request('POST', '/auth/logout', {});
export const apiChangePassword = (currentPassword, newPassword) =>
    request('POST', '/auth/change_password', { current_password: currentPassword, new_password: newPassword });
export const apiForgotPassword = (email) => request('POST', '/auth/forgot_password', { email });
export const apiTokenInfo = (token) => request('POST', '/auth/token_info', { token });
export const apiSetPassword = (purpose, token, password) =>
    request('POST', purpose === 'invite' ? '/auth/accept_invite' : '/auth/reset_password', { token, password });

// Jetons API de son propre compte (page « Mon compte », connecteur Claude).
export const myTokensApi = {
    list: () => request('GET', '/auth/api_tokens'),
    create: (label) => request('POST', '/auth/api_tokens', { label }),
    revoke: (tokenId) => request('DELETE', `/auth/api_tokens/${tokenId}`),
};

// URL du serveur MCP distant : le jeton API s'ajoute au bout (…/mcp/wlt_…).
export const MCP_URL = process.env.REACT_APP_MCP_URL || 'https://mcp-walter.osc-fr1.scalingo.io/mcp';

export const adminApi = {
    listUsers: () => request('GET', '/admin/users'),
    createUser: (user) => request('POST', '/admin/users', user),
    updateUser: (userId, changes) => request('PUT', `/admin/users/${userId}`, changes),
    deleteUser: (userId) => request('DELETE', `/admin/users/${userId}`),
    // Le lien part par email sauf sendEmail=false ; la réponse donne aussi l'URL, copiable en secours.
    createLink: (userId, sendEmail = true) => request('POST', `/admin/users/${userId}/link`, { send_email: sendEmail }),
    revokeSessions: (userId) => request('DELETE', `/admin/users/${userId}/sessions`),
    listTokens: (userId) => request('GET', `/admin/users/${userId}/api_tokens`),
    createToken: (userId, label) => request('POST', `/admin/users/${userId}/api_tokens`, { label }),
    revokeToken: (tokenId) => request('DELETE', `/admin/api_tokens/${tokenId}`),
};
